import { Component, OnInit, Input } from '@angular/core';

/* Text Diff */
import { Observable, Subject } from 'rxjs';

export type DiffTableFormat = 'SideBySide' | 'LineByLine';
export type SideDiff = 'both' | 'left' | 'right';
export interface DiffTableFormatOption {
  id: string;
  name: string;
  label: string;
  value: DiffTableFormat;
  icon?: string;
  disabled?: boolean;
}
export interface DiffContent {
  leftContent: string;
  rightContent: string;
}
export interface DiffPart {
  content: string;
  isDiff: boolean;
}
export interface DiffLineResult {
  lineNumber: number;
  prefix: string;
  lineContent: string;
  lineDiffs: DiffPart[];
}
export interface DiffTableRowResult {
  leftContent: DiffLineResult;
  rightContent: DiffLineResult;
  belongTo: SideDiff;
  hasDiffs: boolean;
  numDiffs: number;
}
export interface DiffResults {
  hasDiff: boolean;
  diffsCount: number;
  rowsWithDiff: {
    leftLineNumber?: number;
    rightLineNumber?: number;
    numDiffs: number;
  }[];
}

@Component({
  selector: 'app-servicing-card',
  templateUrl: 'servicing-card.component.html',
  styleUrls: ['servicing-card.component.scss']
})
export class ServicingCardComponent implements OnInit {

  @Input() data:any = {
    status: 'completed'
  };

  i = Math.ceil(Math.random()*10);
  isCollapsed = true;

  /* Text Diff vars */
  submitted = false;
  content: DiffContent = {
    leftContent: '',
    rightContent: ''
  };
  contentPhone: DiffContent = {
    leftContent: '',
    rightContent: ''
  };
  options: any = {
    lineNumbers: false,
    mode: 'xml'
  };
  contentObservable: Subject<DiffContent> = new Subject<DiffContent>();
  contentObservable$: Observable<DiffContent> = this.contentObservable.asObservable();

  constructor() { }

  ngOnInit() {
    setTimeout(()=>{this.submitted = true},400);
    this.content.leftContent =
    'H 2002, The Abode, Ashwood Drive' + '\n' +
    '7th Number Street' + '\n' +
    'Iowa 50515';
    this.content.rightContent =
    'H 2002, The Abode, Ashwood Drive' + '\n' +
    'Aston Street' + '\n' +
    'Iowa 50515';

    this.contentPhone.leftContent = '9671909900';
    this.contentPhone.rightContent = '9671909988';
  }

  submitComparison() {
    this.submitted = false;
    this.contentObservable.next(this.content);
    this.submitted = true;
  }

  handleChange(side: 'left' | 'right', value: string) {
    switch (side) {
      case 'left':
        this.content.leftContent = value;
        break;
      case 'right':
        this.content.rightContent = value;
        break;
      default:
        break;
    }
  }

  onCompareResults(diffResults: DiffResults) {
    console.log('diffResults', diffResults);
  }

  /* Edit modal */
  modalContent: string = '';
  modalOpen: boolean = false;
  editContents(obj: DiffContent) {
    this.modalContent = obj.rightContent;
    this.modalOpen = true;
  }

}
